export const environment = {
  production: true,
  PAYMENT_API_BASE_URL: "https://vault-sandbox.joinblvd.com",
  MAIN_URL : 'http://localhost:3010/chat', //local
  // MAIN_URL : ' https://middleware.ostlive.com/chat', //live
//  CHECKOUT_URL : 'http://localhost:4200/checkout'
  CHECKOUT_URL : 'https://blvd-chatbot.ostlive.com/checkout',
  PAYMENT_ENCRYPTION_KEY: 'cffb12f2250bad556f81e0fda891685c6a1576386e9baf3d14f954e745f4a9cb',
};
